import { useMenuContext } from "@/lib/context/MenuProvider/hooks/useMenuContext";
import { useDevice } from "@/lib/hooks/useDevice";

export const useOutsideClickListener = () => {
  const { isOpened, setIsOpened } = useMenuContext();
  const { isMobile } = useDevice();

  const onClickOutside = () => {
    if (isOpened && isMobile) {
      setIsOpened(false);
    }
  };

  return {
    onClickOutside,
  };
};
